import type { ReactNode } from "react";

function SignUpStepHeading({
  stepNumber,
  totalSteps,
  title,
  description,
}: {
  stepNumber: number;
  totalSteps: number;
  title: string;
  description: string;
}) {
  return (
    <div className="mb-[26px] flex flex-col items-center text-center">
      <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.28em] text-muted-foreground">
        Step {stepNumber} of {totalSteps}
      </p>
      <h1 className="mt-[11px] max-w-[440px] text-balance text-[25px] font-semibold leading-tight tracking-[-0.5px] text-foreground">
        {title}
      </h1>
      <p className="mt-2 max-w-[390px] text-balance text-sm leading-[1.55] text-muted-foreground">
        {description}
      </p>
    </div>
  );
}

export function SignUpStepLayout({
  stepNumber,
  totalSteps,
  title,
  description,
  children,
  footer,
}: {
  stepNumber: number;
  totalSteps: number;
  title: string;
  description: string;
  children: ReactNode;
  footer: ReactNode;
}) {
  return (
    <>
      <SignUpStepHeading
        description={description}
        stepNumber={stepNumber}
        title={title}
        totalSteps={totalSteps}
      />
      <div className="flex w-full justify-center">{children}</div>
      {footer}
    </>
  );
}
